class GlobalListeners {
  constructor() {
    this.selectors = {
      quickAdds: '[quick-add-qf]',
      productForms: '[action="/cart/add"]:not(.ctl-product-form [action="/cart/add"])',
      openSideCart: '.openSideCart',
      closeSideCart: '.closeSideCart',
      closeSideCartOverlay: '.closeSideCartOverlay',
      removeButtons: '.cart .items-wrapper .item .remove-item',
      quantitySelectorPlus: '.cart .items-wrapper .item .quantity-wrapper .plus',
      quantitySelectorMinus: '.cart .items-wrapper .item .quantity-wrapper .minus',
      cartCount: '.cart-count',
      accordion: 'accordion', 
      product_description: '.product-description-container[read-more-qf]',
      quickview: '[open-quick-view]',
      quickviewModal: '.quick-view-container',
      quickviewClose: '.quick-view-container .close',
    };

    this.init();
  }

  init() {
    window.log("Initializing global QF listeners");
    document.body.addEventListener('click', this.handleEvent.bind(this));
    this.productForm();
    this.productCards();
    this.cartRelated();
    this.headerSearch();
    this.headerNav();
    this.mobileMenu();
    this.sideCartTabs();
    this.pullouts();
  }

  handleEvent(e) {
    this.productQuickAdd(e);
    this.siteCart(e);
    this.quantityButtons(e);
    this.removeCartItem(e);
    this.accordions(e);
    this.productDescriptions(e);
    this.openQuickView(e);
    this.closeQuickView(e);
  }

  productQuickAdd(e) {
    // PRODUCT QUICK ADD
    const quickAdd = e.target.closest(this.selectors.quickAdds);
    if (quickAdd) {
      e.preventDefault();
      const quantity = parseInt(quickAdd.dataset.quantity);
      if (quickAdd.dataset.id && quantity > 0) {
        window.cart.add({ items: [{ "id": quickAdd.dataset.id, "quantity": quantity }] });
      }
    }
  }

  productForm() {
    // PRODUCT FORM LISTENER
    const productForms = document.querySelectorAll(this.selectors.productForms);
    productForms.forEach(productForm => {
      productForm.addEventListener("submit", e => {
        e.preventDefault();
        const quantity = productForm.querySelector("input.quantity-selector").value;
        const id = productForm.querySelector("#product-id").value;
        if (quantity && id) {
          window.cart.add({ items: [{ "id": id, "quantity": quantity }] });
        }
      });
    });
  }

  productCards() {
    const productCardColours = document.querySelectorAll('.product-card-colors');

    if (productCardColours) {
      productCardColours.forEach((el) => {
        const colourAction = el.querySelector('.js-product-card-colors');

        colourAction.addEventListener('click', (e) => {
          el.classList.toggle('active');
        })
      })
    }
  }

  siteCart(e) {
    // SITE CART OPEN AND CLOSE
    if (!window.QF.settings.sideCart) return;
    
    const openSideCart = e.target.closest(this.selectors.openSideCart);
    if (openSideCart) {
      e.preventDefault();
      window.cart.openSideCart();
    }

    const closeSideCart = e.target.closest(this.selectors.closeSideCart);
    if (closeSideCart) {
      e.preventDefault();
      window.cart.closeSideCart();
    }

    const closeSideCartOverlay = e.target.closest(this.selectors.closeSideCartOverlay);
    if (closeSideCartOverlay) {
      e.preventDefault();
      window.cart.closeSideCart();
    }
  }

  quantityButtons(e) {
    // QUANTITY PLUS CART
    const quantityPlus = e.target.closest(this.selectors.quantitySelectorPlus);
    if (quantityPlus) {
      if (quantityPlus.getAttribute("data-pending") === "true") return;
      quantityPlus.setAttribute("data-pending", true);

      const quantityElement = quantityPlus.parentNode.querySelector(".quantity span");
      const stock = quantityElement.getAttribute("data-stock");
      const variant_id = quantityElement.getAttribute("data-variant-id");
      const inv_policy = quantityElement.getAttribute("data-inventory-policy");
      if (inv_policy === "continue" || stock > 0) {
        // if in stock or continue selling when out of stock, update cart
        window.cart.add({ items: [{ "id": variant_id, "quantity": 1 }] });
      }
    }

    // QUANTITY MINUS CART
    const quantityMinus = e.target.closest(this.selectors.quantitySelectorMinus);
    if (quantityMinus) {
      if (quantityMinus.getAttribute("data-pending") === "true") return;
      quantityMinus.setAttribute("data-pending", true);

      const quantity = quantityMinus.parentNode.querySelector(".quantity span");
      const current = parseInt(quantity.innerHTML);
      const variant_id = quantity.getAttribute("data-variant-id");

      if (current > 0) {
        const updated = current - 1;
        window.cart.update({ updates: { [variant_id]: updated } });
      }
    }
  }

  removeCartItem(e) {
    // REMOVE ITEM CART
    const removeButtons = e.target.closest(this.selectors.removeButtons);
    if (removeButtons) {
      const variant_id = removeButtons.getAttribute("data-variant-id");
      window.cart.remove(variant_id);
    }
  }

  cartRelated() {
    // update side cart/cart after change
    const renderCarts = () => {
      if (window.template === "cart") {
        window.cart.reRenderCart();
      } else {
        if (window.QF.settings.ajax_open_side_cart) {
          window.cart.openSideCart();
        } else if (window.QF.settings.ajax_toast) {
          window.cart.reRenderSideCart();
        }
      }
    };
    window.addEventListener("cart_changed", renderCarts);
    window.addEventListener("item_removed", renderCarts);

    // CART COUNT
    window.addEventListener("cart_changed", e => {
      if (e.detail.cart) {
        const cartCount = document.querySelectorAll(".cart-count");
        cartCount.forEach(count => {
          count.innerHTML = e.detail.cart.item_count;
        });
      }
    });
  }

  headerSearch() {
    const search = document.querySelector('.mega-menu .mega-menu-controls .header-search-bar-wrapper');
    const searchTrigger = document.querySelector('.mega-menu .mega-menu-controls [data-open-search]');
    const searchInput = document.querySelector('.mega-menu .mega-menu-controls .header-search-bar-wrapper .search-bar-qf input');

    // Check Search exists
    if (search) {
      // Open / Close Search
      window.addEventListener('click', e => {
        const target = e.target;

        if (target.hasAttribute('data-open-search')) {
          if (target.classList.contains('active')) {
            // Return if active
            return;
          } else {
            // Open if not active
            searchTrigger.classList.add('active');
            search.classList.add('active');
            searchInput.focus();
          }
        } else if (target.classList.contains('header-search') || target.getAttribute('id') === 'submit_search') {
          // Do nothing if search is clicked
          return;
        } else {
          // Close if clicked off
          searchTrigger.classList.remove('active');
          search.classList.remove('active');
        }
      });

      // Close search with Escape Key
      window.addEventListener('keydown', e => {
        const key = e.key;

        if (key === 'Escape') {
          if (window.activeElement.classList.contains('header-search')) {
            searchTrigger.classList.remove('active');
            search.classList.remove('active');
          } else {
            return;
          }
        }
      });
    }

  }

  headerNav() {
    const headerNavMenus = document.querySelectorAll('.header-nav .top-level-link-megamenu');

    if (headerNavMenus) {
        headerNavMenus.forEach((menu) => {
            menu.addEventListener('click', (e) => {
                e.preventDefault();

                // Make this active
                const dataId = menu.getAttribute('data-id');
                const thisSecondLevel = document.querySelector(`.top-level-links-wrapper[data-id="${dataId}"]`);

                // Check if the menu is active
                const isActive = menu.classList.contains('active');

                // Remove all others
                headerNavMenus.forEach((menu) => { menu.classList.remove('active'); });
                const secondLevels = document.querySelectorAll('.top-level-links-wrapper');
                if (secondLevels) {
                    secondLevels.forEach((level) => { level.classList.remove('active'); });
                }

                // Toggle active class
                if (!isActive) {
                    menu.classList.add('active');
                    if (thisSecondLevel) {
                        thisSecondLevel.classList.add('active');
                    }
                }

            });
        });
    }
  }

  mobileMenu() {
    const headerSection = document.querySelector('.mega-menu');
    const menu = document.querySelector('.mobile-menu-outer-wrapper');
    const menuTrigger = document.querySelector('#open-mobile-menu');
    const body = document.body;

    if (menuTrigger) {
      menuTrigger.addEventListener('click', () => {
        if (menuTrigger.classList.contains('active')) {
          headerSection.classList.remove('active');
          menu.classList.remove('active');
          menuTrigger.classList.remove('active');
          body.classList.remove('fixed');
        } else {
          headerSection.classList.add('active');
          menu.classList.add('active');
          menuTrigger.classList.add('active');
          body.classList.add('fixed');
        }
      });
    }

    menu.addEventListener('click', e => {
      if (e.target.classList.contains('mobile-menu-outer-wrapper')) {
        headerSection.classList.remove('active');
        menu.classList.remove('active');
        menuTrigger.classList.remove('active');
      }
    });

    // Mobile menu level 2
    const mobileNavMenus = document.querySelectorAll('.mobile-nav .top-level-link-megamenu');

    if (mobileNavMenus) {
        mobileNavMenus.forEach((menu) => {
            menu.addEventListener('click', (e) => {
                e.preventDefault();

                // Make this active
                const dataId = menu.getAttribute('data-id');
                const thisSecondLevel = document.querySelector(`.mobile-menu-links[data-id="${dataId}"]`);

                // Check if the menu is active
                const isActive = menu.classList.contains('active');

                // Remove all others
                mobileNavMenus.forEach((menu) => { menu.classList.remove('active'); });
                const secondLevels = document.querySelectorAll('.mobile-menu-links');
                if (secondLevels) {
                    secondLevels.forEach((level) => { level.classList.remove('active'); });
                }

                // Toggle active class
                if (!isActive) {
                    menu.classList.add('active');
                    if (thisSecondLevel) {
                        thisSecondLevel.classList.add('active');
                    }
                }

            });
        });
    }

    // Mobile menu submenus
    const mobileLinkChildren = document.querySelectorAll('.mobile-link-has-children');
    const mobileCloseSubmenu = document.querySelector('.mobile-menu-close-submenu');
    const mobileBreadcrumbCurr = document.querySelector('.mobile-menu-breadcrumb-curr');
    const mobileNav = document.querySelector('.mobile-menu-navigation');

    if (mobileLinkChildren) {
      mobileLinkChildren.forEach((children) => {
        const openSubmenu = children.querySelector('.open-children');
        const submenu = children.querySelector('.mobile-link-children');
  
        openSubmenu.addEventListener('click', (e) => {
          e.preventDefault;

          const linkText = openSubmenu.parentElement.querySelector('.link').innerText;

          mobileNav.scrollTop = 0;
          mobileNav.classList.add('fixed');
          submenu.classList.add('active');
          mobileCloseSubmenu.classList.add('active');
          mobileBreadcrumbCurr.classList.add('active');

          mobileBreadcrumbCurr.innerText = linkText;
        });
      });
    }

    if (mobileCloseSubmenu) {
      mobileCloseSubmenu.addEventListener('click', (e) => {
        e.preventDefault;
        mobileCloseSubmenu.classList.remove('active');
        mobileBreadcrumbCurr.classList.remove('active');

        mobileBreadcrumbCurr.innerText = 'Home';
        
        mobileNav.classList.remove('fixed');
        const activeSubmenus = document.querySelectorAll('.mobile-link-children.active');
        activeSubmenus.forEach((submenu) => {
          submenu.classList.remove('active');
        });
      });
    }
  }

  sideCartTabs() {
    const cart_tabs = document.querySelectorAll('.cart-tab');

    cart_tabs.forEach(tab => {
      tab.addEventListener('click', (e)=> {
        tab.classList.remove('active');
        if (!e.target.closest('.cart-tab').classList.contains('active')) {
          cart_tabs.forEach(tab => {
            tab.classList.remove('active');
          })
          let tab_selected = e.target.closest('.cart-tab');
          tab_selected.classList.add('active')
          let tab_data = tab_selected.getAttribute('data-tab');
          let cart_contents = document.querySelectorAll('.cart-content');
          cart_contents.forEach(cart_content => {
            cart_content.style.display = 'none';
          })
          document.querySelector('.' + tab_data).style.display = 'flex';
          if (tab_data == 'saved-cart') {
            if(window.wishlist.needsUpdate){
              window.wishlist.initSideCartGrid();
              window.wishlist.needsUpdate = false; 
            }
          }
        }
      })
    })
  }

  accordions(e) {
    if (e.target.classList.contains(this.selectors.accordion) ) {
      e.preventDefault();
      
      const accordion = e.target;
      const parent = accordion.parentElement;
      const sibling_accordions = parent.getElementsByClassName(this.selectors.accordion);
      const panel = accordion.nextElementSibling;
        
      if (sibling_accordions.length > 0) {
        Array.from(sibling_accordions).forEach((acc) => {
            if (acc != accordion || accordion.classList.contains('active')) {
                acc.nextElementSibling.style.maxHeight = null;
                acc.classList.remove("active");

            } else {
                accordion.classList.add("active");
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
      }
      
    }
  }

  productDescriptions(e) {
      if ( e.target.classList.contains('read-more') ) {
        let el = e.target;

        if (el.classList.contains("active")) {
          el.classList.remove("active");
          el.innerHTML = "Read more";
        } else {
          el.classList.add("active");
          el.innerHTML = "Read less";
        }

      }
    
  }

  pullouts(e) {

    const pulloutOverlay = document.querySelector('.pullout-overlay');
    const openPullout = document.querySelectorAll('[data-open-pullout]');
    const closePullout = document.querySelectorAll('[data-close-pullout]');

    const pullouts = document.querySelectorAll('.pullout');

    openPullout.forEach((open) => {
      open.addEventListener('click', (e) => {
        e.preventDefault();

        document.body.classList.add('pullout-active');
        pulloutOverlay.classList.add('active');

        let thisID = open.getAttribute('data-open-pullout');
        if(thisID === 'location'){
          window.initLoadLocation(true,true)
        }
        const pullout = document.querySelector(`.pullout-${thisID}`);

        pullout.classList.add('active');
      })
    })

    // Close pullout
    closePullout.forEach((close) => {
      close.addEventListener('click', (e) => {
        e.preventDefault();

        document.body.classList.remove('pullout-active');
        pulloutOverlay.classList.remove('active');

        pullouts.forEach((pullout) => {
          pullout.classList.remove('active');
        });
      })
    })

    pulloutOverlay.addEventListener('click', (e) => {
      e.preventDefault();

      document.body.classList.remove('pullout-active');
      pulloutOverlay.classList.remove('active');

      pullouts.forEach((pullout) => {
        pullout.classList.remove('active');
      });
    })

  }

  openQuickView(e) {
    // OPEN QUICK VIEW
    const quickView = e.target.closest(this.selectors.quickview);
    if (quickView) {
      e.preventDefault();
      let pageHasRecomendations = document.querySelector(".product-recommendations") || false;
      let timeout = pageHasRecomendations ? 0 : 0;

      setTimeout(async () => {
          let quickViewModal = document.querySelector(this.selectors.quickviewModal);

          if (quickViewModal) {
            let quickViewModalInner = quickViewModal.querySelector(".inner");

            let sectionName = "la-main-product";
            let handle = quickView.getAttribute("data-product-handle");
            
            if (handle) {
              try {
                const response = await fetch(`/products/${handle}?sections=${sectionName}`);
                if (response.ok) {
                  const data = await response.json();
                  let script_index = 2;
                  let html = data[`${sectionName}`];
    
                  let script_parts = html.split("<script>");
                  let script = script_parts[script_index].replace("</script>", "");
                  script = script.replace("</div>", "");
                  script = script.replace('document.addEventListener("DOMContentLoaded", () => {', "");
                  let closingBraceLocation = script.lastIndexOf("})");
    
                  // Remove the scroll event listener code
                  script = script.replace(/window\.addEventListener\('scroll',[\s\S]*?\}\);/, '');
    
                  // Close script
                  script = script.substring(0, closingBraceLocation);
    
                  if (quickViewModalInner && html) {
                    quickViewModalInner.innerHTML = html;

                    let sectionNameInformation = "la-product-information-quick-view";
                    const response_pi = await fetch(`/products/${handle}?sections=${sectionNameInformation}`);

                    if (response_pi.ok) {
                      const data_pi = await response_pi.json();
                      let script_index_pi = 1;
                      let html_pi = data_pi[`${sectionNameInformation}`];

                      let script_parts_pi = html_pi.split("<script>");
                      let script_pi = script_parts_pi[script_index_pi].replace("</script>", "");
                      script_pi = script_pi.replace("</div>", "");
                      script_pi = script_pi.replace('document.addEventListener("DOMContentLoaded", () => {', "");
                      let closingBraceLocation_pi = script_pi.lastIndexOf("})");
        
                      // Remove the scroll event listener code
                      script_pi = script_pi.replace(/window\.addEventListener\('scroll',[\s\S]*?\}\);/, '');
        
                      // Close script
                      script_pi = script_pi.substring(0, closingBraceLocation_pi);

                      if (quickViewModalInner && html_pi) {

                        quickViewModalInner.innerHTML += html_pi;

                        // Combine scripts
                        let combinedScript = script + "\n" + script_pi;
                        eval(combinedScript); // Execute combined scripts

                      }

                    } else {
                      throw new Error('Error: ' + response_pi.status);
                    }
    
                    // init sliders
                    let gallery_thumbs_swiper = new window.swiper(".inner .thumb-swiper", {
                      spaceBetween: 8,
                      slidesPerView: 5,
                      freeMode: true,
                      watchSlidesProgress: true,
                      direction: "horizontal",
                      loop: false,
                      breakpoints: {
                        992: {
                          slidesPerView: 'auto',
                          direction: "vertical",
                          autoHeight: true,
                          slidesOffsetBefore: 16,
                          slidesOffsetAfter: 16
                        },
                      },
                    });
    
                    let gallery_swiper = new window.swiper(".inner .main-swiper", {
                      spaceBetween: 20,
                      navigation: {
                        nextEl: ".inner .swiper-button-next",
                        prevEl: ".inner .swiper-button-prev",
                      },
                      pagination: {
                        el: '.quick-view-modal .main-swiper-pagination',
                        clickable: true,
                        dynamicBullets: true,
                        dynamicMainBullets: 5,
                      },
                      thumbs: {
                        swiper: gallery_thumbs_swiper,
                      },
                      on: {
                        init: function () {
                          let check_width = setInterval(() => {
                            setThumbHeight();
                          }, 200);
    
                          function setThumbHeight() {
                            let main_swiper_slide = document.querySelector('.inner .main-swiper-slide');
                            let thumb_swiper_slide = document.querySelector('.inner .swiper-slide.thumb');
                            let thumb_swiper = document.querySelector('.inner .thumb-swiper');
    
                            let main_swiper_width = main_swiper_slide.offsetWidth;
    
                            main_swiper_slide.style.height = main_swiper_width + 'px';
    
                            if (main_swiper_width > 0) {
                              clearInterval(check_width);
    
                              thumb_swiper.style.cssText = "position: relative;opacity:1";
    
                              if (window.innerWidth > 991.98) {
                                thumb_swiper.style.height = main_swiper_width + 'px';
                              }
                            }
                          }
    
                          document.querySelector('.inner .gallery-container').style.opacity = 1;
    
                          window.addEventListener('resize', () => {
                            let main_swiper_slide = document.querySelector('.inner .main-swiper');
                            let thumb_swiper_slide = document.querySelector('.inner .swiper-slide.thumb');
                            let thumb_swiper = document.querySelector('.inner .thumb-swiper');
    
                            let main_swiper_width = main_swiper_slide.offsetWidth;
    
                            main_swiper_slide.style.height = main_swiper_width + 'px';
    
                            if (window.innerWidth > 991.98) {
                              thumb_swiper.style.height = main_swiper_width + 'px';
                            }
                          });
                        },
                      },
                    });
    
                    // add listeners to product form
                    let productForm = quickViewModalInner.querySelector('[action="/cart/add"]');
    
                    if (productForm) {
                      productForm.addEventListener("submit", function (e) {
                        e.preventDefault();
    
                        let quantity = productForm.querySelector("input.quantity-selector").value;
                        let id = productForm.querySelector("#product-id").value;
    
                        if (quantity && id) {
                          window.cart.add({ items: [{ "id": id, "quantity": quantity }] });
                        }
                      });
                    }
    
                    // add listener for read more
                    let read_more = quickViewModalInner.querySelector(".product-description-container[read-more-qf]");
    
                    if (read_more) {
                      let read_more_control = read_more.querySelector(".read-more");
                      let excerpt = read_more.querySelector("span.excerpt");
                      let full = read_more.querySelector("span.full");
    
                      read_more_control.addEventListener("click", () => {
                        if (read_more.classList.contains("active")) {
                          read_more.classList.remove("active");
                          read_more_control.innerHTML = "Read more";
                        } else {
                          read_more.classList.add("active");
                          read_more_control.innerHTML = "Read less";
                        }
                      });
                    }
    
                    // Show quick view modal
                    quickViewModal.classList.add("active");
                    document.body.classList.add('fixed');
                  }
                } else {
                  throw new Error('Error: ' + response.status);
                }
              } catch (error) {
                console.error(error);
              }
            }
        }
      }, timeout);
    }
  }

  closeQuickView(e) {
    // CLOSE QUICK VIEW
    const quickViewClose = e.target.closest(this.selectors.quickviewClose);
    if (quickViewClose) {
      e.preventDefault();
      const quickViewModal = document.querySelector(this.selectors.quickviewModal);
      if (quickViewModal) {
        quickViewModal.classList.remove("active");
        document.body.classList.remove('fixed');
      }
    }
  }

}

window.GlobalListeners = GlobalListeners;
